/**
 * URL helpers for public marketing pages (classes, teachers).
 */

/** @deprecated Prefer `appendFromClassQuery` - kept for any external references. */
export const PUBLIC_TEACHER_RETURN_CLASS_ID = "gh_publicTeacherReturnClassId";

/** @deprecated Prefer `appendFromClassQuery` - kept for any external references. */
export const PUBLIC_LOCATION_RETURN_CLASS_ID = "gh_publicLocationReturnClassId";

export { appendFromClassQuery, PUBLIC_FROM_CLASS_QUERY } from "./publicReturnToClass";
export {
  appendFromListingQuery,
  appendFromTeacherQuery,
  appendPublicReturnQuery,
  PUBLIC_FROM_QUERY,
  PUBLIC_FROM_TEACHER_QUERY,
  type PublicReturnListing,
} from "./publicReturnToClass";

/** Slug segment for a readable URL path (lowercase, hyphenated). */
export function slugifyPublicSegment(input: string): string {
  const s = input
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return s.length > 0 ? s : "item";
}

export function buildTeacherPublicPath(teacher: {
  firstName: string;
  lastName: string;
  teacherId: number;
}): string {
  const slug = `${slugifyPublicSegment(teacher.firstName)}-${slugifyPublicSegment(teacher.lastName)}-${teacher.teacherId}`;
  return `/teachers/${slug}`;
}

/** Class list item may only have name + id - matches [slug] parsing (id = last segment). */
export function buildClassPublicPath(classItem: { name: string; classId: number }): string {
  return `/classes/${slugifyPublicSegment(classItem.name)}-${classItem.classId}`;
}

/** Prefer backend slug when set so sitemap/canonical URLs match in-app links. */
export function resolveClassPublicPath(classItem: {
  name: string;
  classId: number;
  slug?: string | null;
}): string {
  const apiSlug = classItem.slug?.trim();
  if (apiSlug) {
    return `/classes/${apiSlug}`;
  }
  return buildClassPublicPath({
    name: classItem.name,
    classId: classItem.classId,
  });
}

export function buildLocationPublicPath(location: {
  name: string;
  locationId: number;
}): string {
  const slug = `${slugifyPublicSegment(location.name)}-${location.locationId}`;
  return `/locations/${slug}`;
}

